/**
 * TanStack Query mutation for fetching a presigned download URL for a material.
 * GET /api/course-materials/:id/download-url — fetched on demand (click), not pre-fetched.
 */
import { useMutation } from '@tanstack/react-query';
import { api } from '@client/lib/api-client';

export function useMaterialDownloadUrl() {
  return useMutation({
    mutationFn: (materialId: string) =>
      api.get<{ url: string }>(`/api/course-materials/${materialId}/download-url`),
  });
}
